<script>
	import { setContext, onDestroy, onMount } from "svelte";
	import { Flight } from './flight'
	import { enableGlobalOverlay, disableGlobalOverlay } from "../map";

	export let flight
	export let guest = false
	export let multiFlight = false

	let flightClass

	setContext("flight", {
		get: () => flightClass
	});

	onMount(() => {
		console.log('context onMount')
		flightClass = new Flight(flight, guest)
		flightClass.multiFlight = multiFlight
		window.flight = flightClass
		if (!multiFlight) disableGlobalOverlay()
	})
	onDestroy(() => {
		flightClass.cleanup()
		if (!multiFlight) enableGlobalOverlay()
	})
</script>

{#if flightClass}
	<slot/>
{/if}